import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'gatsby';

import CircularArrow from 'components/circularArrow';

import {
  learnMore,
  learnMoreWhiteTheme,
  learnMoreRegularTheme,
  regularArrow,
  learnMoreContainer,
} from './scss/LearnMore.module.scss';

const LearnMore = ({
  prefix,
  context,
  arrow,
  arrowType,
  theme,
  className,
  tag,
  href,
  ...others
}) => {
  const Tag = tag;
  const themeClassName = {
    white: learnMoreWhiteTheme,
    regular: learnMoreRegularTheme,
  }[theme];
  const arrowClassName = classNames(arrow, {
    [regularArrow]: theme === 'regular',
  });
  const tagProps = {
    ...(href && tag === 'a' ? { href } : { to: href }),
    ...others,
  };

  return (
    <Tag {...tagProps} className={learnMoreContainer}>
      <div className={classNames(learnMore, themeClassName, className)}>
        <CircularArrow type={arrowType} className={arrowClassName} />
        <div>
          <small>{prefix}</small>
          <h3>{context}</h3>
        </div>
      </div>
    </Tag>
  );
};

LearnMore.propTypes = {
  theme: PropTypes.oneOf(['white', 'regular']),
  arrowType: PropTypes.string,
  prefix: PropTypes.string,
  context: PropTypes.string.isRequired,
  className: PropTypes.string,
  href: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

LearnMore.defaultProps = {
  theme: 'regular',
  arrowType: 'primary',
  prefix: 'LEARN MORE ABOUT',
  className: '',
  href: '/',
  tag: Link,
};

export default LearnMore;
